import React from 'react';

import lunchLogo from '../../../img/logo-lunch-team.svg';

import '../PrivacyTerms/privacyTerms.scss';

// Public page for app-store account-deletion requirements (Google Play asks for a web URL).
export function DeleteAccount() {
  return (
    <main className="main">
      <header className="head">
        <img src={lunchLogo} alt="Lunch Team Logo" />
      </header>

      <div className="content-terms">
        <a href="/Menu" className="back-link">
          Back
        </a>
        <h2>Delete your Lunch.Team account</h2>
        <div className="text-content">
          <p>You can delete your Lunch.Team account and the personal data linked to it at any time.</p>

          <h3>In the app</h3>
          <p>
            Open the Lunch.Team app on iPhone or Android, go to <b>Settings</b> and tap{' '}
            <b>Delete Account</b>. Your account is closed straight away and you can no longer sign in. We then
            erase your personal data as described below.
          </p>

          <h3>By email</h3>
          <p>
            If you can't use the app, email{' '}
            <a href="mailto:support@lunch.team?subject=Delete%20my%20Lunch.Team%20account">support@lunch.team</a>{' '}
            from the email address you sign in with, with the subject "Delete my Lunch.Team account". We confirm by
            email when your request has been completed, within one month.
          </p>

          <h3>What we erase and what we keep</h3>
          <p>
            We erase your profile (name, email address and phone number), your saved delivery addresses and your app
            notification details, and remove any saved cards from our payment provider.
          </p>
          <p>
            Records of orders and payments that we must keep for tax, accounting and your company's invoices are
            kept only for as long as the law requires, then deleted. They are not used for marketing.
          </p>
        </div>
      </div>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Landing/DeleteAccount/index.js